// extracted by mini-css-extract-plugin
export var container = "_8u-0";
export var icon = "_8u-1";
export var text = "_8u-2";